import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis.ts";
import { ActiveEnums } from "@app/data/engine.ts";
import { handleApiError } from "@app/helpers/error-helper.tsx";
import { useMutation } from "@tanstack/react-query";
import { useQuery } from "bi-lib";

export default function usePowerBiReportsData() {
    const apis = useApis();

    const reportsListQuery = useQuery({
        queryKey: [QueryKeys.PowerBiReports],
        queryFn: () => apis.engine.powerBiReports.powerBiReportsReportsListList(),
    });

    const generateProjectManagementPmJustPostedChargesReportMutation = useMutation({
        mutationFn: (parameters: {
            /** @format int32 */
            amountTypeId?: number;
            entryIds?: Array<string>;
        }) =>
            apis.engine.powerBiReports.powerBiReportsGenerateProjectManagementPmJustPostedChargesReportList(parameters),
        onSuccess: (response) => {
            window.open(
                `/report?accessToken=${encodeURIComponent(response.accessToken!)}&embedUrl=${encodeURIComponent(response.reportUrl!)}`,
                "_blank",
            );
        },
        onError: (error: Error) => handleApiError(error, "Failed to generate report"),
    });

    const generateReportMutation = useMutation({
        mutationFn: ({
            reportId,
            parameters,
        }: {
            reportId: number;
            parameters: {
                fromDt?: string;
                toDt?: string;
                staffId?: number[];
                staffTypeId?: number;
                sortingId?: number;
                amountTypeId?: number;
                utilCodeId?: number;
                assignmentId?: number;
                postedId?: ActiveEnums;
                activeId?: ActiveEnums;
                billableAssignmentId?: ActiveEnums;
                billableId?: ActiveEnums;
                invoiceId?: number;
                invoiced?: ActiveEnums;
                invoiceVisibleId?: ActiveEnums;
                logo?: number;
            };
        }) => apis.engine.powerBiReports.powerBiReportsGenerateReportDetail(reportId, parameters),
        onSuccess: (response) => {
            window.open(
                `/report?accessToken=${encodeURIComponent(response.accessToken!)}&embedUrl=${encodeURIComponent(response.reportUrl!)}`,
                "_blank",
            );
        },
        onError: (error: Error) => handleApiError(error, "Failed to generate report"),
    });

    return {
        reportsList: reportsListQuery,

        generateReport: generateReportMutation,
        generateProjectManagementPmJustPostedChargesReport: generateProjectManagementPmJustPostedChargesReportMutation,
    };
}
